module.exports = __webpack_public_path__ + "img/1.9a4f706a.svg";